// @flow

import gql from 'graphql-tag';

const appsOverviewQuery = gql`
  query appsOverviewQuery($slugs: [String!]!) {
    appsBySlug(slugs: $slugs) {
      id
      image
      name
      description
      primaryColor
      slug

      partnerStatus {
        tier
      }

      categories {
        name
      }
    }
  }
`;

export default appsOverviewQuery;
